<template>
  <div>
    <h-btn
      :flat='true'
      color='primary'
      @click="show"
    >Add Clients</h-btn>
    <modal 
      v-if="display" 
      @close="display=false" 
      @submit="save"
      btn="Save"
      title="Add Clients">
        <div v-if="loading">Loading Clients</div>
        <v-checkbox v-for="client in clients"
          v-model="selected"
          :label="client.first_name + ' ' + client.last_name"
          :value="client.id"
          :key="client.id"
          color="primary"></v-checkbox>
  </modal>
  </div>
</template>

<script>
import dataStore from "@/services/api/store";
import modal from "@/components/modal/default";
import _ from "lodash";
const STORE_CLIENTS = "CoachClients";

export default {
  components: { modal },
  data() {
    return {
      display: false,
      clients: [],
      selected: [],
      saving: false,
      loading: false
    };
  },
  methods: {
    save() {
      let selected = this.selected.map(id =>
        this.clients.find(c => c.id == id)
      );
      this.$emit("finished", selected);
      this.display = false;
    },
    show() {
      this.loading = true;
      this.display = true;
      dataStore
        .findAll(STORE_CLIENTS, { limit: 1000 }, { force: true })
        .then(clients => {
          this.clients = _.sortBy(clients, [(o) => o.first_name.toLowerCase()])
        })
        .then(() => {
          this.loading = false;
        });
    }
  }
};
</script>
